





















import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import {
  NOW_YEAR, Stats, thMonthsMini, timeframeSubtract,
} from '@/utils';
import LineChart from '@/components/Vivat/Chart/LineChart.vue';

import deliveryTimeMonths from '@/gql/managementReport/04-DeliveryTime/deliveryTimeMonths.gql';

const LineChartWithLastYearCompare = defineComponent({
  components: {
    LineChart,
  },
  props: {
    title: { default: 'ระยะเวลาจัดส่ง' },
    xAxisLabel: { default: 'เดือน' },
    yAxisLabel: { default: 'จำนวนวัน' },
    height: {},
  },
  setup() {
    const filter = reactive({
      year: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });
    const { result: deliveryTimeMonthsResult } = useQuery(deliveryTimeMonths, computed(() => ({
      timeframe: filter.year,
      timeframeY1: timeframeSubtract(filter.year),
    })));
    const computedDeliveryTime = computed(() => deliveryTimeMonthsResult.value || ({
      overall: [],
      overallY1: [],
      ftl: [],
      ftlY1: [],
      ltl: [],
      ltlY1: [],
    }));

    const chartData = computed(() => ({
      labels: thMonthsMini,
      datasets: [
        {
          label: 'FTL (Y-1)',
          name: 'FTL (Y-1)',
          data: computedDeliveryTime.value.ftlY1.map((val: Stats) => val.amount),
          borderColor: 'rgba(19, 72, 137, 0.4)',
          backgroundColor: 'rgba(19, 72, 137, 0.4)',
        },
        {
          label: 'LTL (Y-1)',
          name: 'LTL (Y-1)',
          data: computedDeliveryTime.value.ltlY1.map((val: Stats) => val.amount),
          borderColor: 'rgba(181, 36, 96, 0.5)',
          backgroundColor: 'rgba(181, 36, 96, 0.5)',
        },
        {
          label: 'FTL',
          name: 'FTL',
          data: computedDeliveryTime.value.ftl.map((val: Stats) => val.amount),
          borderColor: 'rgba(19, 72, 137, 1)',
          backgroundColor: 'rgba(19, 72, 137, 1)',
        },
        {
          label: 'LTL',
          name: 'LTL',
          data: computedDeliveryTime.value.ltl.map((val: Stats) => val.amount),
          borderColor: 'rgba(181, 36, 96, 1)',
          backgroundColor: 'rgba(181, 36, 96, 1)',
        },
        {
          label: 'รวม (Y-1)',
          name: 'รวม (Y-1)',
          data: computedDeliveryTime.value.overallY1.map((val: Stats) => val.amount),
          borderColor: 'rgba(241, 150, 58, 0.5)',
          backgroundColor: 'rgba(241, 150, 58, 0.5)',
        },
        {
          label: 'รวม',
          name: 'รวม',
          data: computedDeliveryTime.value.overall.map((val: Stats) => val.amount),
          borderColor: 'rgba(241, 150, 58, 1)',
          backgroundColor: 'rgba(241, 150, 58, 1)',
        },
      ],
    }));

    return {
      filter,
      chartData,
    };
  },
});

export default LineChartWithLastYearCompare;
